export const ff_task_ui_createcoveragetab = 'ff_task_ui_createcoveragetab';
export const ff_ui_showhomecoverage = 'ff_ui_showhomecoverage';
export const ff_notifications_coverage_email = 'ff_notifications_coverage_email';
export const ff_notifications_coverage_sms = 'ff_notifications_coverage_sms';